import React from 'react';
import {IdentifyForm} from "./IdentifyForm";

/**
 * Component used to identify the user
 */

export class Identify extends React.Component<any, any> {

    public render(): any {

        return (
            <div >
                <h1>Welcome</h1>

                <div style={{display:'flex'}}>
                    <div>
                        <div style={{paddingLeft: 100, width: '320px'}}>
                            <div className="box" >
                                <div className="box-body">
                                    <img className="img" src="https://miro.medium.com/max/700/1*ITPWdo1leQjJ4mogqBvrlQ.png" width={320} height={180}/>
                                    <div className="box-lid" >
                                        <div className="box-bowtie" > </div >

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div style={{flexGrow:100}} >

                        <p>Welcome to VGift! It looks like someone out there really cares about you {String.fromCodePoint(0x1F970)}.</p>

                        <p>They got you a gift {String.fromCodePoint(0x1F381)}! But before we get started unwrapping this bad boy, we need to know who you are {String.fromCodePoint(0x1F9D0)}!</p>

                        <p>To get started, simply type in your email address below.</p>

                        <IdentifyForm/>
                    </div>
                </div>

            </div>

        );
    }
}
